module.exports = __webpack_public_path__ + "static/media/PlesantlyPickledcanningcompanysign2012Enamelonpanel.05c4b3f9.webp";